/**
 * SD-13787: Steps of the admin login modal.
 *
 * These values were previously duplicated as bare numbers - the logout flow in footer.ts
 * emitted a literal `7` at the modal's private `LoginActionEnum`. Naming them here lets the
 * footer and the modal agree on a step without a cross-component event.
 */
export enum ADMIN_MODAL_STEP {
    Login = 1,
    ForgotPassword = 2,
    GetCode = 3,
    EnterCode = 4,
    LoginSuccess = 5,
    AccountLocked = 6,
    LogoutSuccess = 7,
}
